package com.ragnorak.clanybackoffice.ui.screens

import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.setValue
import androidx.lifecycle.ViewModel
import androidx.lifecycle.viewModelScope
import com.clany.backoffice.domain.usecase.GetSystemConfigsUseCase
import com.clany.backoffice.model.SystemConfigResponse
import dev.zacsweers.metro.Inject
import kotlinx.coroutines.launch

data class MetadataUiState(
    val isLoading: Boolean = false,
    val configs: List<SystemConfigResponse> = emptyList(),
    val error: String? = null,
    val page: Int = 1,
    val hasMore: Boolean = true,
    val searchQuery: String = ""
)

class MetadataViewModel @Inject constructor(
    private val getSystemConfigsUseCase: GetSystemConfigsUseCase
) : ViewModel() {

    var uiState by mutableStateOf(MetadataUiState())
        private set

    init {
        loadConfigs()
    }

    fun loadConfigs(page: Int = 1) {
        viewModelScope.launch {
            uiState = uiState.copy(isLoading = true, error = null)
            getSystemConfigsUseCase(
                page = page,
                pageSize = 20,
                query = uiState.searchQuery.ifBlank { null }
            )
                .onSuccess { configs ->
                    uiState = uiState.copy(
                        isLoading = false,
                        configs = if (page == 1) configs else uiState.configs + configs,
                        page = page,
                        hasMore = configs.isNotEmpty()
                    )
                }
                .onFailure {
                    uiState = uiState.copy(isLoading = false, error = it.message)
                }
        }
    }

    fun onSearchQueryChanged(query: String) {
        uiState = uiState.copy(searchQuery = query)
        loadConfigs(page = 1)
    }
}
